// Compact amounts for funding calls, in the call's own currency: €2.5M, $750K, £40K.
const SIGNS = {
  EUR: '€', USD: '$', GBP: '£', JPY: '¥', CNY: '¥', TRY: '₺', INR: '₹', KRW: '₩',
  CHF: 'CHF ', AUD: 'A$', CAD: 'C$', NZD: 'NZ$', BRL: 'R$', ZAR: 'R ',
};

export function currencySign(currency = 'EUR') {
  return SIGNS[currency] || `${currency} `;
}

export function formatCompactMoney(amount, currency = 'EUR') {
  const n = Number(amount);
  if (!n) return null;
  const sign = currencySign(currency || 'EUR');
  if (n >= 1000000) return `${sign}${(n / 1000000).toFixed(1)}M`;
  if (n >= 1000) return `${sign}${(n / 1000).toFixed(0)}K`;
  return `${sign}${n}`;
}
